// Firebase placeholder config
import { initializeApp } from 'firebase/app';
import { addDoc, collection, getFirestore } from 'firebase/firestore';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAV6Dhio2zLSlGeR_uzFyH0biR2ncGVQjg",
  authDomain: "wazo-d6e9d.firebaseapp.com",
  projectId: "wazo-d6e9d",
  storageBucket: "wazo-d6e9d.firebasestorage.app",
  messagingSenderId: "37243660711",
  appId: "1:37243660711:web:e58fe4e715166acc7eae82",
  measurementId: "G-QXKK6Q550H"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

export async function submitInquiry(data) {
  try {
    await addDoc(collection(db, "inquiries"), {
      ...data,
      createdAt: new Date(),
    });
    return { ok: true };
  } catch (error) {
    console.error("🔥 Firestore Error:", error.code, error.message);
    return { ok: false };
  }
}